import type { AppDispatch, RootState } from '@/store';
import { resetCreateSixState, setDraftFromSix } from '@/store/slices/createSix/createSixSlice';
import {
  openModal,
  closeModal,
  setPollingError,
  setPollingSuccess,
} from '@/store/slices/ui/uiSlice';
import type { Six } from '@/types/six/Six';

/**
 * Opens the 'editUser' modal.
 */
export const showEditUserModal = () => (dispatch: AppDispatch) => {
  dispatch(openModal({ modal: 'editUser', modalProps: {} }));
};

/**
 * Opens the 'inviteExternal' modal.
 */
export const showInviteExternalModal = () => (dispatch: AppDispatch) => {
  dispatch(openModal({ modal: 'inviteExternal', modalProps: {} }));
};

/**
 * Opens the 'createSix' modal.
 */
export const showCreateSixModal = () => (dispatch: AppDispatch) => {
  dispatch(openModal({ modal: 'createSix', modalProps: {} }));
};
/**
 * Opens the 'createSix' modal in 'Edit' mode.
 * Populates the form with existing SIX data.
 */
export const showEditSixModal = (six: Six) => (dispatch: AppDispatch, getState: () => RootState) => {
  dispatch(resetCreateSixState());
  const state = getState();
  const participants = state.sixDetail.participants;

  dispatch(setDraftFromSix({six, participants}));
  dispatch(openModal({ modal: 'createSix', modalProps: {} }));
};

/**
 * Opens the 'updatePassword' modal.
 */
export const showUpdatePasswordModal = () => (dispatch: AppDispatch) => {
  dispatch(openModal({ modal: 'updatePassword', modalProps: {} }));
};

/**
 * Closes any open modal.
 */
export const hideModal = () => (dispatch: AppDispatch) => {
  dispatch(closeModal());
};

export const showPollingError =
  (title: string, message: string, details?: Record<string, unknown> | null) =>
  (dispatch: AppDispatch) => {
    dispatch(setPollingError({ title, message, details: details ?? null }));
  };

export const showPollingSuccess =
  (
    title: string,
    message: string,
    resourceUrl?: string | null,
    details?: Record<string, unknown> | null
  ) =>
  (dispatch: AppDispatch) => {
    dispatch(setPollingSuccess({ title, message, resourceUrl: resourceUrl ?? null }));
  };
